import { defineComponent } from "vue";

export default defineComponent({
  name: "BrandLogoSmall",
  props: {
    useCurrentColor: Boolean,
  },
  setup(props) {
    return () => (
      <div class="relative">
        <a href="https://www.sippulse.com" target="_blank" class="default-focus">
          <svg
            class="h-full w-full dark:brightness-0 dark:invert"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 443.92 635.8"
          >
            <defs></defs>
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <path
                  fill={props.useCurrentColor ? "currentColor" : "#006eb7"}
                  d="M443.92,221.62C443.92,99.22,344.71,0,222.31,0S0,98.66,0,221.05V635.8H59.14V221.16h0c.08-90,73.36-163.27,163.42-163.27S386,131.2,386,221.31,312.68,384.74,222.57,384.74h0v.16H164.44v58.71h61.23v-.42c120.84-1.79,218.25-100.3,218.25-221.57"
                />
                <path
                  fill={props.useCurrentColor ? "currentColor" : "#192959"}
                  d="M366.1,220.94c0-79.3-64.51-143.82-143.81-143.82S78.47,141.64,78.47,220.94V586.4h59.76V426.62c-.16-.06.15-.11,0-.17V364h-.06V230.64s.22-6.39.22-8.17a81.42,81.42,0,0,1,81.91-81.82,82.49,82.49,0,0,1,82.49,82.49c0,43.57-37.91,81.88-81.11,82.63l-5,.1s-13.42.49-26.09.49H164.23l-.08,58.87h61.23l1,0C304.23,363.6,366.1,299.2,366.1,220.94"
                />
              </g>
            </g>
          </svg>
        </a>
      </div>
    );
  },
});
